import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { openWidgetPopupInShell } from '@/utils/SessionUtils';
import cssStyles from './Dropdown.css';

class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.editProfile = this.editProfile.bind(this);
  }

  editProfile() {
    const { session } = this.props;
    openWidgetPopupInShell('widgets/profile/ProfileUpdate', {
      _session: session,
      containerClass: 'edit-profile adder_dialog',
      dimensions: {
        height: 'auto',
        width: 'auto',
      },
    });
  }

  render() {
    return (
      <div
        role='menuitem'
        tabIndex='-1'
        onKeyDown={() => {}}
        className={classNames(cssStyles.dropdown_list_item)}
        onClick={this.editProfile}
      >
        <div className={cssStyles.menu_item_info}>
          <div className={classNames(cssStyles.menu_item_label)}>
            <FormattedMessage id='edit_profile' />
          </div>
        </div>
      </div>
    );
  }
}

EditProfile.propTypes = {
  session: PropTypes.object.isRequired,
};

export default EditProfile;



// WEBPACK FOOTER //
// ./src/components/appMenu/EditProfile.js